import { AlarmActivation } from '@repo/sdk/models/components';

import { UseWebsocketQueryOptions } from '@/hooks/query-hooks/websockets';
import { GaiaQueryWithAgentId, QueryToast } from '@/queries/types';

export const activeAlarmActivationsQuery = ({
  agentId,
}: GaiaQueryWithAgentId): UseWebsocketQueryOptions<AlarmActivation[] | null> => {
  return {
    enabled: !!agentId,
    queryKey: [agentId, 'alarmActivations'],
    staleTime: Infinity,
    meta: {
      toast: {
        severity: 'off',
      } as QueryToast,
    },
    webSocketUrl: `/bff/v1/agents/${agentId}/alarms-stream`,
  };
};
